import {
  addClass,
  removeClass,
  setAriaExpandedTrue,
  setAriaExpandedFalse
} from '//framemymirror.com/cdn/shop/t/55/assets/utils.js?v=47311905765003806461747769281'

export default class MultiAccordion {
  constructor (accordionQueryString) {
    this.accordionsContainer = document.querySelector(`${accordionQueryString}`)
    this.accordionContainers = this.accordionsContainer?.querySelectorAll(
      '[data-accordion-container]'
    )
    this.init(this.accordionContainers)
  }

  init (accordionContainers) {
    if (accordionContainers == undefined) {
      return
    }

    accordionContainers.forEach(accordionContainer => {
      const accordionHeader = accordionContainer.querySelector(
        '[data-accordion-header]'
      )
      const accordionBody = accordionContainer.querySelector(
        '[data-accordion-body]'
      )
      const accordionContent = accordionContainer.querySelector(
        '[data-accordion-content]'
      )

      accordionHeader &&
        accordionHeader.addEventListener('click', () => {
          this.handleHeaderClick(
            accordionHeader,
            accordionBody,
            accordionContent
          )
        })
    })
  }

  // Handle events
  handleHeaderClick (accordionHeader, accordionBody, accordionContent) {
    accordionHeader &&
      accordionHeader.addEventListener('click', () => {
        accordionHeader.classList.contains('open')
          ? this.closeAccordion(
              accordionHeader,
              accordionBody,
              accordionContent
            )
          : this.openAccordion(accordionHeader, accordionBody, accordionContent)
      })
  }

  //Middleware
  openAccordion (accordionHeader, accordionBody, accordionContent) {
    this.closeAllAccordions()
    addClass(accordionHeader, 'open')
    setAriaExpandedTrue(accordionHeader)
    this.setOpenHeight(accordionHeader,accordionBody, accordionContent)
  }

  closeAccordion (accordionHeader, accordionBody, accordionContent) {
    removeClass(accordionHeader, 'open')
    setAriaExpandedFalse(accordionHeader)
    this.setClosedHeight(accordionBody, accordionContent)
  }

  closeAllAccordions () {
    this.accordionContainers.forEach(accordionContainer => {
      const containerElements = this.getAccordionElements(accordionContainer)
      this.closeAccordion(...containerElements)
    })
  }

  getAccordionElements (accordionContainer) {
    const accordionHeader = accordionContainer.querySelector(
      '[data-accordion-header]'
    )
    const accordionBody = accordionContainer.querySelector(
      '[data-accordion-body]'
    )
    const accordionContent = accordionContainer.querySelector(
      '[data-accordion-content]'
    )
    return [accordionHeader, accordionBody, accordionContent]
  }

  //DOM manipulation
  setOpenHeight (accordionHeader,accordionBody, accordionContent) {
    accordionBody.style.height = `${accordionContent.offsetHeight}px`
  }

  setClosedHeight (accordionBody) {
    accordionBody.style.height = '0px'
  }
}